module.exports = __webpack_public_path__ + "img/NBL1East.25a04ce3.png";